module.exports = __webpack_public_path__ + "img/17.140d93d0.png";